import { FC, memo } from 'react'

import { ArrowRightIcon } from '@cash-me/react-components'

import { pushDataLayer } from 'utils/push-data-layer'

import { CardProps } from './card.model'
import * as S from './styles'

export const Card: FC<CardProps> = memo(
  ({
    children,
    background = 'neutral-background-default',
    border = 'neutral-border-default',
    link,
    ariaLabel,
    dataLayer,
    className
  }) => (
    <S.Wrapper $background={background} $border={border} className={className}>
      {children}
      {link && (
        <S.Link {...(dataLayer && { onClick: () => pushDataLayer(dataLayer) })} href={link} aria-label={ariaLabel}>
          Saiba mais
          <ArrowRightIcon color="var(--colors-primary-icon-default)" size={24} />
        </S.Link>
      )}
    </S.Wrapper>
  )
)

Card.displayName = 'Card'
